/*
    - Author: @aday - hola@adayhenriquez.com
    - Version: 1.1.0
    - Date: 2025-06-25
    - Description: This script is used to observe the cart and check if all products have flavors.
    - Log: Implement overlay and filter for curated products.
*/

const cartObserver = onCartChange => {

    const fetchAndNotify = () => {
        fetch('/cart.js')
        .then(response => response.json())
        .then(cart => onCartChange(cart))
        .catch(console.error);
    }

    fetchAndNotify();

    const cartContainer = document.querySelector('[data-cart-container], .cart, #CartContainer');

    if(cartContainer) {
        const observer = new MutationObserver(() => {
            fetchAndNotify();
        });
        observer.observe(cartContainer, { childList: true, subtree: true });
    }
};

cartObserver(cart => {

    if(cart.items.length === 0) {
        return;
    }

    if(cart.items.length > 0) {
        cart.items.forEach(item => {

            const productType = item.product_type.toLowerCase();
            const itemTags= document.querySelector(`[data-line-item="${item.key}"]`)?.dataset.lineItemTags || '';

            if((productType === 'bagels' || productType === 'box sets') && !itemTags.includes('|curated|')) {

                let hasPk = false;
                const pkKeys = Object.keys(item.properties ?? {}).filter(key => key.toLowerCase().includes('pk'));

                if (pkKeys.length === 0) {
                    return hasPk;
                }

                hasPk = pkKeys.every(key => {
                    const value = item.properties[key];
                    return value !== undefined && value !== null && value.trim() !== '';
                });

                /*
                    for(const [key, value] of Object.entries(item.properties)) {
                        if(key.toLowerCase().includes('pk') && value !== undefined && value !== null && value !== '') {
                            hasPk = true;
                            break;
                        }
                    }
                */

                if(!hasPk) {

                    const overlay = document.getElementById('flavor-overlay');
                    const link = overlay?.querySelector('a.button');
                    const removeLink = overlay?.querySelector('a.link');

                    if(overlay && link) {
                        overlay.style.display = "flex";
                        link.setAttribute('href', `${item.url}&key=${item.key}`);
                        removeLink.setAttribute('href', `/cart/change?id=${item.key}&quantity=0`);
                    }

                    return;
                }
            }
        });
    }
});